import { render, staticRenderFns } from "./BannerStoreActive.vue?vue&type=template&id=352d3caa&scoped=true&lang=pug"
import script from "./BannerStoreActive.vue?vue&type=script&lang=js"
export * from "./BannerStoreActive.vue?vue&type=script&lang=js"
import style0 from "./BannerStoreActive.vue?vue&type=style&index=0&id=352d3caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d3caa",
  null
  
)

export default component.exports